import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CollapsibleCardComponent } from './collapsible-card.component';

/**
 * This component is used to conditionally render its content when parent rt-collapsible-card is collapsed.
 */
@Component({
  selector: 'rt-collapsed-card-child',
  template: `@if (collapsibleCard.isCollapsed()) {
    <ng-content></ng-content>
  }`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsedCardChildComponent {
  constructor(public collapsibleCard: CollapsibleCardComponent) {}
}
